import axios from 'config/api';
import { FETCH_CLIPPINGS_SUCCESS } from 'config/constants';

export function fetchClippings() {
  return axios
    .get(`/user/events`)
    .then(({ data, status }) => {
      if (status === 200) {
        return {
          type: FETCH_CLIPPINGS_SUCCESS,
          data: data,
        };
      }

      throw new Error();
    })
    .catch(error => {
      console.error('Por favor, entre em contato com o suporte.', error);
      throw error;
    });
}
